import React from "react";
import "./landing.scss";
import sliderLogo from "../../../resources/images/SPOT-LP-Buehne.svg";
import lp_de from "../../../resources/images/SPOT-LP-Beispielrechnung_DE.svg";
import lp_en from "../../../resources/images/SPOT-LP-Beispielrechnung_EN.svg";
import lp_pl from "../../../resources/images/SPOT-LP-Beispielrechnung_PL.svg";
import lp_tr from "../../../resources/images/SPOT-LP-Beispielrechnung_TR.svg";
import lp_de_mobile from "../../../resources/images/SPOT-LP-Beispielrechnung_mobile_DE.svg";
import lp_en_mobile from "../../../resources/images/SPOT-LP-Beispielrechnung_mobile_EN.svg";
import lp_pl_mobile from "../../../resources/images/SPOT-LP-Beispielrechnung_mobile_PL.svg";
import lp_tr_mobile from "../../../resources/images/SPOT-LP-Beispielrechnung_mobile_TR.svg";
import { SPOTButton } from "spot-component-library/lib/components/SPOTButton";
import rateAgreementService from "../../services/RateAgreementService";
import { Trans, useTranslation } from "react-i18next";
import { SPOTNotification } from "spot-component-library/lib/components/notification/SPOTNotification";
import { LinkText } from "../../components/link/LinkText";
import AppContainer from "spot-component-library/lib/components/layout/app-container/AppContainer";
import i18next from "i18next";
import { Spinner } from "spot-component-library/lib/components/basic/spinner/Spinner";
import { readLanguageFromCookie } from "../../utils/helper";
import { Etracker } from "spot-component-library/lib/components/etracker/Etracker";
import { useTenant } from "../../contexts/TenantContext";
import { createLoginBundleScript } from "../../utils/login-module";

export function Landing() {
    const { t } = useTranslation();
    const [showFaq1, setShowFaq1] = React.useState<boolean>(false);
    const [showFaq2, setShowFaq2] = React.useState<boolean>(false);
    const [showFaq3, setShowFaq3] = React.useState<boolean>(false);
    const [showFaq4, setShowFaq4] = React.useState<boolean>(false);
    const [showFaq5, setShowFaq5] = React.useState<boolean>(false);
    const [checkRateAgreement, setCheckRateAgreement] = React.useState<boolean>(true);
    const [rateAgreementOption, setRateAgreementOption] = React.useState<string>("");
    const [errorMessage, setErrorMessage] = React.useState<string>();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [isPageLoaded, setIsPageLoaded] = React.useState(false);

    const { tenant } = useTenant();

    React.useEffect(() => {
        if (tenant) {
            setIsPageLoaded(true);
            createLoginBundleScript(debtLoginListener);
        }
    }, [tenant]);

    const debtLoginListener = (debtId: string) => {
        checkRateAgreementAvailable(debtId);
    };

    const checkRateAgreementAvailable = async (debtNumber: string) => {
        setIsLoading(true);
        try {
            const isAvailable = await rateAgreementService.isRateAgreementAvailable(debtNumber as string);

            if (isAvailable) {
                setCheckRateAgreement(false);
                setRateAgreementOption("rateAgreementSuccess");
            } else {
                setCheckRateAgreement(false);
                setRateAgreementOption("rateAgreementError");
            }
        } catch (error) {
            setRateAgreementOption("rateAgreementError");
            switch ((error as Error).message) {
                case "404":
                    setErrorMessage(t("APP_ROOT.ERROR.MESSAGE_404"));
                    break;
                case "422":
                    setErrorMessage(t("APP_ROOT.ERROR.MESSAGE_422"));
                    break;
                default: {
                    setErrorMessage(t("APP_ROOT.ERROR.SERVER_MESSAGE_DEFAULT"));
                    break;
                }
            }
        }
        setIsLoading(false);
    };

    const handleOnClickUrl = () => {
        window.location.href = "/services/rateagreement";
    };

    const handleOnClickUrlPayment = () => {
        window.location.href = "/index.xhtml";
    };

    const faqQuestion1 = () => {
        if (showFaq1) {
            setShowFaq1(false);
        } else {
            setShowFaq1(true);
        }
    };

    const faqQuestion2 = () => {
        if (showFaq2) {
            setShowFaq2(false);
        } else {
            setShowFaq2(true);
        }
    };

    const faqQuestion3 = () => {
        if (showFaq3) {
            setShowFaq3(false);
        } else {
            setShowFaq3(true);
        }
    };

    const faqQuestion4 = () => {
        if (showFaq4) {
            setShowFaq4(false);
        } else {
            setShowFaq4(true);
        }
    };

    const faqQuestion5 = () => {
        if (showFaq5) {
            setShowFaq5(false);
        } else {
            setShowFaq5(true);
        }
    };

    return (
        <AppContainer header={{ menuLoginEnabled: true }}>
            {tenant?.name && <Etracker pageName={"RateAgreement-ABOSuccess"} popto={"1500"} tenant={tenant.name} language={readLanguageFromCookie()} />}

            {isPageLoaded && (
                <div>
                    <div className="sliderLanding">
                        <h2>
                            <Trans i18nKey="LANDING_PAGE.SLIDER_HEADLINE" />
                        </h2>
                        <div className="block_text">
                            <p>
                                <Trans i18nKey="LANDING_PAGE.SLIDER_TEXT" />
                            </p>
                            <img src={sliderLogo} alt="Ratenzahlung" />
                        </div>
                    </div>
                    <div className="contentBlock">
                        <div className="debtnoBox">
                            {checkRateAgreement && (
                                <div className="inlineView">
                                    <h4>{t("LANDING_PAGE.SEARCH_BOX_HEADLINE")}</h4>
                                    {!isLoading && (
                                        <div className="debtBlock">
                                            {/* Debt id login is loaded from login service to this id */}
                                            <div id="login-debt-id" data-button-text={t("LANDING_PAGE.SUBMIT_BUTTON")} data-button-position="Right"></div>

                                            {errorMessage && (
                                                <div style={{ paddingTop: 10 }}>
                                                    <SPOTNotification type="error" active={true} text={t("APP_ROOT.ERROR.SERVER_MESSAGE_DEFAULT")}></SPOTNotification>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    <Spinner isLoading={isLoading} type="page" color={"grey"} />
                                </div>
                            )}
                            {!checkRateAgreement && (
                                <div>
                                    {rateAgreementOption === "rateAgreementSuccess" && (
                                        <div className="blockSuccessRate">
                                            <h3>{t("LANDING_PAGE.SUCCESS_HEADLINE")}</h3>
                                            <div>
                                                <i className="icon-checkmark"></i>
                                                <p>{t("LANDING_PAGE.SUCCESS_TEXT")}</p>
                                            </div>
                                            <SPOTButton type="primary" label={t("LANDING_PAGE.LINK_TO_RATECALCULATION")} onClick={handleOnClickUrl}></SPOTButton>
                                        </div>
                                    )}
                                    {rateAgreementOption === "rateAgreementError" && (
                                        <div className="blockSuccessRate">
                                            <h3>{t("LANDING_PAGE.ERROR_HEADLINE")}</h3>
                                            <div>
                                                <i className="icon-cancel-V2"></i>
                                                <p>{t("LANDING_PAGE.ERROR_TEXT")}</p>
                                            </div>
                                            <SPOTButton type="primary" label={t("LANDING_PAGE.LINK_TO_PAYMNET")} onClick={handleOnClickUrlPayment}></SPOTButton>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="textBlock textBlock1">
                            <div className="block1">
                                <i className="icon-rate-agreement-notes" />
                                <div>
                                    <h4>{t("LANDING_PAGE.RATE_PLAN_HEADLINE1")}</h4>
                                    <p>{t("LANDING_PAGE.RATE_PLAN_TEXT1")}</p>
                                </div>
                            </div>
                            <div className="block2">
                                <i className="icon-tasks"></i>
                                <div>
                                    <h4>{t("LANDING_PAGE.RATE_PLAN_HEADLINE2")}</h4>
                                    <p>{t("LANDING_PAGE.RATE_PLAN_TEXT2")}</p>
                                </div>
                            </div>
                        </div>
                        <div className="textBlock">
                            <div className="ratenplan">
                                <div className="ratenplanImageDesktop">
                                    <img
                                        src={
                                            i18next.language === "de"
                                                ? lp_de
                                                : i18next.language === "en"
                                                  ? lp_en
                                                  : i18next.language === "pl"
                                                    ? lp_pl
                                                    : i18next.language === "tr"
                                                      ? lp_tr
                                                      : lp_de
                                        }
                                        alt={t("LANDING_PAGE.RATE_PLAN_IMAGE_ALT_TAG")}
                                    />
                                </div>
                                <div className="ratenplanImageMobile">
                                    <img
                                        src={
                                            i18next.language === "de"
                                                ? lp_de_mobile
                                                : i18next.language === "en"
                                                  ? lp_en_mobile
                                                  : i18next.language === "pl"
                                                    ? lp_pl_mobile
                                                    : i18next.language === "tr"
                                                      ? lp_tr_mobile
                                                      : lp_de
                                        }
                                        alt={t("LANDING_PAGE.RATE_PLAN_IMAGE_ALT_TAG")}
                                    />
                                </div>
                            </div>
                            <div className="faq">
                                <div className="faqHeadline">
                                    <i className="icon-exchange-V1"></i>
                                    <h4>{t("LANDING_PAGE.FAQ_HEADLINE")}</h4>
                                </div>
                                <div className="faqBlock">
                                    <p className="faqHeadline" onClick={faqQuestion1}>
                                        {t("LANDING_PAGE.FAQ_QUESTION1_HEADLINE")}
                                        {!showFaq1 && (
                                            <span>
                                                <i className="icon-resource-gain"></i>
                                            </span>
                                        )}
                                        {showFaq1 && (
                                            <span>
                                                <i className="icon-minus"></i>
                                            </span>
                                        )}
                                    </p>
                                    {showFaq1 && (
                                        <div className="faqTextBlock">
                                            <p>{t("LANDING_PAGE.FAQ_QUESTION1_TEXT1")}</p>
                                            <p>
                                                {t("LANDING_PAGE.FAQ_QUESTION1_TEXT2")}
                                                <ul>
                                                    <li>{t("LANDING_PAGE.FAQ_QUESTION1_TEXT3")}</li>
                                                    <li>{t("LANDING_PAGE.FAQ_QUESTION1_TEXT4")}</li>
                                                    <li>{t("LANDING_PAGE.FAQ_QUESTION1_TEXT5")}</li>
                                                </ul>
                                            </p>
                                        </div>
                                    )}
                                    <p className="faqHeadline" onClick={faqQuestion2}>
                                        {t("LANDING_PAGE.FAQ_QUESTION2_HEADLINE")}
                                        {!showFaq2 && (
                                            <span>
                                                <i className="icon-resource-gain"></i>
                                            </span>
                                        )}
                                        {showFaq2 && (
                                            <span>
                                                <i className="icon-minus"></i>
                                            </span>
                                        )}
                                    </p>
                                    {showFaq2 && (
                                        <div className="faqTextBlock">
                                            <p>{t("LANDING_PAGE.FAQ_QUESTION2_TEXT1")}</p>
                                            <br />
                                            <p>{t("LANDING_PAGE.FAQ_QUESTION2_TEXT2")}</p>
                                            <p>{t("LANDING_PAGE.FAQ_QUESTION2_TEXT3")}</p>
                                            <p>
                                                <Trans
                                                    i18nKey="LANDING_PAGE.FAQ_QUESTION2_TEXT4"
                                                    components={{
                                                        link1: <LinkText to={"https://www.eos-serviceportal.de/services/contactform"} title="contact" />,
                                                    }}
                                                />
                                            </p>
                                        </div>
                                    )}
                                    <p className="faqHeadline" onClick={faqQuestion3}>
                                        {t("LANDING_PAGE.FAQ_QUESTION3_HEADLINE")}
                                        {!showFaq3 && (
                                            <span>
                                                <i className="icon-resource-gain"></i>
                                            </span>
                                        )}
                                        {showFaq3 && (
                                            <span>
                                                <i className="icon-minus"></i>
                                            </span>
                                        )}
                                    </p>
                                    {showFaq3 && (
                                        <div className="faqTextBlock">
                                            <p>{t("LANDING_PAGE.FAQ_QUESTION3_TEXT1")}</p>
                                            <br />
                                            <p>{t("LANDING_PAGE.FAQ_QUESTION3_TEXT2")}</p>
                                            <p>
                                                <Trans
                                                    i18nKey="LANDING_PAGE.FAQ_QUESTION3_TEXT3"
                                                    components={{
                                                        link1: <LinkText to={"https://www.eos-serviceportal.de/services/contactform"} title="contact" />,
                                                    }}
                                                />
                                            </p>
                                            <p>
                                                <Trans
                                                    i18nKey="LANDING_PAGE.FAQ_QUESTION3_TEXT4"
                                                    components={{
                                                        link1: <LinkText to={"https://www.eos-serviceportal.de/services/contactform"} title="contact" />,
                                                    }}
                                                />
                                            </p>
                                            <p>{t("LANDING_PAGE.FAQ_QUESTION3_TEXT5")}</p>
                                        </div>
                                    )}
                                    <p className="faqHeadline" onClick={faqQuestion4}>
                                        {t("LANDING_PAGE.FAQ_QUESTION4_HEADLINE")}
                                        {!showFaq4 && (
                                            <span>
                                                <i className="icon-resource-gain"></i>
                                            </span>
                                        )}
                                        {showFaq4 && (
                                            <span>
                                                <i className="icon-minus"></i>
                                            </span>
                                        )}
                                    </p>
                                    {showFaq4 && (
                                        <div className="faqTextBlock">
                                            <p>{t("LANDING_PAGE.FAQ_QUESTION4_TEXT1")}</p>
                                            <br />
                                            <p>
                                                <Trans
                                                    i18nKey="LANDING_PAGE.FAQ_QUESTION4_TEXT2"
                                                    components={{
                                                        link1: <LinkText to={"https://www.eos-serviceportal.de/services/contactform"} title="contact" />,
                                                    }}
                                                />
                                            </p>
                                            <p>{t("LANDING_PAGE.FAQ_QUESTION4_TEXT3")}</p>
                                        </div>
                                    )}
                                    <p className="faqHeadline" onClick={faqQuestion5}>
                                        {t("LANDING_PAGE.FAQ_QUESTION5_HEADLINE")}
                                        {!showFaq5 && (
                                            <span>
                                                <i className="icon-resource-gain"></i>
                                            </span>
                                        )}
                                        {showFaq5 && (
                                            <span>
                                                <i className="icon-minus"></i>
                                            </span>
                                        )}
                                    </p>
                                    {showFaq5 && (
                                        <div className="faqTextBlock">
                                            <p>{t("LANDING_PAGE.FAQ_QUESTION5_TEXT1")}</p>
                                            <br />
                                            <p>{t("LANDING_PAGE.FAQ_QUESTION5_TEXT2")}</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <Spinner isLoading={!isPageLoaded} type="page" color={"red"} />
        </AppContainer>
    );
}
